import { useRef, useState, useCallback, useEffect } from 'react';
import { useRouter } from 'next/router';

//* HOC's
import withDataContext from 'context/consumerHOC/DataConsumer';
import withLanguageContext from 'context/consumerHOC/LanguageConsumer';

//* Components
import FormInput from 'components/common/FormInput';
import FormItem from 'components/common/FormItem';
import FormContainer from 'components/common/FormContainer';
import Text from 'components/common/Text';
import Button from 'components/common/Button';

const Subscribe = ({ subscribe, translate }) => {
	//! Router
	const router = useRouter();

	//! Ref
	const formRef = useRef();

	//! State
	const [isEmailSent, setIsEmailSent] = useState(false);

	//! Handle form finish
	const onFinish = useCallback((emailAddress) => {
		setIsEmailSent('loading');

		return subscribe(emailAddress)
			.then(() => {
				setIsEmailSent(true);

				setTimeout(() => {
					setIsEmailSent(false);
				}, 3000);
			})
			.catch((err) => {
				setIsEmailSent(false);

				return Promise.reject(err);
			});
	});

	//! Clear errors or other info from input fields on route change
	useEffect(() => {
		formRef.current && formRef.current.resetFields();
	}, [router]);

	return (
		<div>
			<div className='form-wrap'>
				<Text
					className='h6 font-ping-bolder subscribe-block-text'
					text={'footerSubscribeText'}
				/>

				<FormContainer
					ref={formRef}
					onFinish={onFinish}
					className={`footer-form ${isEmailSent ? 'sending' : ''}`}>
					<div className='footer-inner-wrapper'>
						<FormItem
							name={'email'}
							required={true}
							validationType={'email'}
							className={'footer-form-input'}>
							<FormInput placeholder={translate('footerPlaceholderText')} />
						</FormItem>

						<Button
							text={'subscribe'}
							color={'ColorBigStone'}
							className={'footer-btn'}
							background={'ColorApricot'}
							hoverColor={'ColorBigStone'}
							hoverBackground={'ColorYellowTan'}
							hoverBorderColor={'ColorYellowTan'}
							disabled={isEmailSent === 'loading'}
							isBtnLoad={isEmailSent === 'loading'}
						/>
					</div>
				</FormContainer>

				{isEmailSent && isEmailSent !== 'loading' ? (
					<Text
						text='subscribeSuccessMessage'
						className='footer-form-success-message successColor pXS font-helvetica-regular'
					/>
				) : null}
			</div>
		</div>
	);
};

export default withDataContext(withLanguageContext(Subscribe, ['translate']), ['subscribe']);
